import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { useNavigate } from "react-router-dom";
import RegistrationDropdown from "../../CustomControls/RegistrationDropdown";
import { Endpoints } from "../../Global/Endpoints";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

export const Review_RX = () => {
    const { t, i18n } = useTranslation();
    const {isChatVisible, toggleChat, showChat } = useChat();
    const [reviewData, setReviewData] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [homeQty, setHomeQty] = useState("");
    const userInfo = useSelector((state) => state.userData);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [selectedPharmacy, setSelectedPharmacy] = useState("");
    const [selectedPharmacyCode, setSelectedPharmacyCode] = useState("");
    const [OrderType, setOrderType] = useState("");
    const [showConfirmButtons, setShowConfirmButtons] = useState(false);
    const [cheapestPharmacy, setCheapestPharmacy] = useState("");
    const [cheapestPharmaCode, setCheapestPharmaCode] = useState("");
    const [showNurseModal, setShowNurseModal] = useState(false);
    const [triggerNurseModal, setTriggerNurseModal] = useState(false);
    const [showscheduleModal,setShowscheduleModal]= useState(false);
    const token = localStorage.getItem('AccessToken');
    const [selectedEggFreezing, setSelectedEggFreezing] = useState("No");
    const [showDisneyModal, setShowDisneyModal] = useState(false);

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const location = useLocation();
    const navigate = useNavigate();
    const userTypePremier = userInfo.userData.Premiere;
    const userTypePremierRX = userInfo.userData.PremierRX;
    const authNo = location.state?.authorizationDetail?.AuthNo;
    const initialPharmacyName = location.state?.authorizationDetail?.PharmacyName;
    const initialPharmacyCode=location.state?.authorizationDetail?.PharmacyID;
    //const orderType = location.state?.authorizationDetail?.OrderType;

    useEffect(() => {

        // Set the initial selected pharmacy if provided in authorizationDetail
        if (initialPharmacyName) {
            setSelectedPharmacy(initialPharmacyName);
            setSelectedPharmacyCode(initialPharmacyCode);
        }
        const fetchReviewRXData = async () => {
            try {
                const params = {
                    MemberID: userInfo.userData.MemberID,
                    Contract: userInfo.userData.ContractIdentified,
                    AuthNo: authNo,
                    EmailID: userInfo.userData.EmailID,
                DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
                };
                
                const response = await axios.post(
                    Endpoints.LoadReviewRX,
                    { _Params: JSON.stringify(params) },
                    {
                        //params: { _params: JSON.stringify(params) },
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`, // Adjust token source if necessary
                        }
                    }
                );

                if (response.data) {
                    setReviewData(response.data);
                    setOrderType(response.data.OrderType);
                    // console.log("Review RX Data:", response.data);
                } else {
                    console.error("Unexpected response structure:", response.data);
                }
            } catch (error) {
                console.error("Error fetching Review RX data:", error);
            }
        };

        fetchReviewRXData();
    },  [authNo, initialPharmacyName, userInfo.userData.MemberID, userInfo.userData.ContractIdentified]);

    const handleFindCheapestPharmacy = async () => {
        try {
            const params = {
                PharmCode: selectedPharmacyCode, // Adjust this based on selected pharmacy
                Contract: userInfo.userData.ContractIdentified,
                Rx: reviewData?.Rx?.map(medication => ({
                    RequestedQty: medication.RequestedQty,
                    HomeQty: homeQty[medication.PresId] || "0", // Use the HomeQty from the state or default to "0"
                    DrugName: medication.DrugName,
                    PresId: medication.PresId,
                    NDC: medication.NDC,
                    BalanceQty: medication.BalanceQty || 0, // Default to 0 if not provided
                })) || [],
                AuthNo: authNo,
                MemberID: userInfo.userData.MemberID,
                EmailID: userInfo.userData.EmailID,
                DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            };
            // console.log(params);
            const qs = require("qs"); 
        const formattedParams = qs.stringify({ _Params: JSON.stringify(params) });
            const response = await axios.post(
                Endpoints.FindCheapestPharmacy,
                formattedParams,
                {
                   // params: { _Params: JSON.stringify(params) },
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Connection": "close",
                        "Accept": "*/*",
                        Authorization:  `Bearer ${token}`,
                    }
                }
            );
            // Check for a positive response condition
            if (response.data) {  
                // console.log("Cheapest Pharmacy Response:", response.data);
                // setModalMessage(response.data.CheapestPharmacytext);
                setShowModal(true);
                const cheapestPharmacyName = response.data.CheapestPharmacyName;
                const cheapestPharmacyCode = response.data.PharmCode;
                const message = (cheapestPharmacyName === selectedPharmacy)
                ? `For the selected drugs in your order, the pharmacy you have selected is the best pharmacy.` 
                : `${response.data.CheapestPharmacytext}`;

                setCheapestPharmacy(cheapestPharmacyName);
                setCheapestPharmaCode(cheapestPharmacyCode);

                if (cheapestPharmacyName !== selectedPharmacy) {
                    setShowConfirmButtons(true);
                  }

            setModalMessage(message);
            setShowModal(true);
            } else {
                // Handle the case where the response is not positive
                console.warn("The response was not successful:", response.data);
                setModalMessage("Unable to find the cheapest pharmacy. Please try again.");
                setShowModal(true);
            }
        } catch (error) {
            console.error("Error finding cheapest pharmacy:", error);
        }
    };


    const handleHomeQtyChange = (presId, qty) => {
        setHomeQty((prevHomeQty) => ({
            ...prevHomeQty,
            [presId]: qty,
        }));
    };

    const handlePharmacyChange = (e) => {
        const selectedName = e.target.value;
        const selectedCode = reviewData?.Pharmacies?.find(
            (pharmacy) => pharmacy.PharmName === selectedName
          )?.PharmCode;
        
          setSelectedPharmacy(selectedName);
          setSelectedPharmacyCode(selectedCode);
        // setSelectedPharmacy(e.target.value);
    };

    const handleSubmit = async () => {
        if (!selectedDate) {
            setModalMessage("Please select date before submitting");
            setShowModal(true);
            return; 
        }
        try {
            const formattedDate = selectedDate ? selectedDate.toLocaleDateString("en-US") : "";
            const rxForEggFreeze = selectedEggFreezing || "No";
            let params;
            if(userTypePremier==="Yes" || userTypePremierRX==="Yes"){
             params = {
                AuthNo: authNo,
                PharmCode: selectedPharmacyCode,
                OrderType: OrderType, // Adjust as needed
                Contract: userInfo.userData.ContractIdentified,
                DateMedsNeeded: formattedDate,
                RxForEggFreeze: rxForEggFreeze,
                Rx: reviewData?.Rx?.map(medication => ({
                    RequestedQty: medication.RequestedQty,
                    HomeQty: homeQty[medication.PresId] || "0",
                    DrugName: medication.DrugName,
                    PresId: medication.PresId,
                    NDC: medication.NDC,
                    BalanceQty: medication.BalanceQty || 0,
                })) || [],
                MemberID: userInfo.userData.MemberID,
                EmailID: userInfo.userData.EmailID,
                DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            };
        }else if(userTypePremier==="No" && userTypePremierRX==="No"){

             params = {
                AuthNo: authNo,
                PharmCode: selectedPharmacyCode,
                OrderType: OrderType, // Adjust as needed
                Contract: userInfo.userData.ContractIdentified,
                DateMedsNeeded: formattedDate,
                RxForEggFreeze: rxForEggFreeze,
                Rx: reviewData?.Rx?.map(medication => ({
                    RequestedQty: homeQty[medication.PresId] || "0",
                    NDC: medication.NDC,
                })) || [],
                MemberID: userInfo.userData.MemberID,
                EmailID: userInfo.userData.EmailID,
                DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            };
        }
             console.log("paramsave:",params);
            //const qs = require("qs"); 
           // const formattedParams = qs.stringify({ _Params: JSON.stringify(params) });
            // console.log("paramsformattedqs:",formattedParams);
            const response = await axios.post(
                Endpoints.SaveRxDrugRows,
                { _Params: JSON.stringify(params) },
                {
                    //params: { _Params: JSON.stringify(params) },
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Connection": "close",
                        "Accept": "*/*",
                        Authorization:  `Bearer ${token}`,
                    }
                }
            );
            if (response.data.Data === "Success") {
                // console.log("Save RX Data Response:", response.data);
                setModalMessage(
                    isHighmarkPortal
                      ? "The Fertility and Family Building team will process this request and you will get another notification once this Rx request has been approved."
                      : "The WIN team will process this request and you will get another notification once this Rx request has been approved."
                  );
                setShowNurseModal(true);
                setTriggerNurseModal(true);
            } else {
                console.warn("Failed to submit the data:", response.data);
                setModalMessage("Failed to submit the data. Please try again.");
                //setModalMessage("The WIN team will process this request and you will get another notification once this Rx request has been approved.");
                // setShowNurseModal(true);
                // setTriggerNurseModal(true);
                setShowModal(true);
            }
            //setShowModal(true);
        } catch (error) {
            console.error("Error submitting data:", error);
            setModalMessage("An error occurred while submitting. Please try again.");
            setShowModal(true);
        }
    };

    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
      };

      const handleOkayClick = () => {
        // Update pharmacy when Okay is clicked
        setSelectedPharmacy(cheapestPharmacy);
        setSelectedPharmacyCode(cheapestPharmaCode);
        setShowModal(false);
        setShowConfirmButtons(false);

        // if (triggerNurseModal) {
        //     setShowNurseModal(true);
        //     setTriggerNurseModal(false); // Reset the flag
        // }

      };
            // Handle Dropdown Change for Elective Egg Freezing Cycle
            const handleEggFreezingChange = (e) => {
                const value = e.target.value || "No"; 
            
                // Update the state with the new value
                setSelectedEggFreezing(value);
            
                // If the answer is Yes and the user is a Disney-Cigna Allegiance or Disney-HMSA Kaiser member, show the modal
                if (
                value === "Yes" &&
                (userInfo.userData.ContractIdentified === "Disney-Cigna Allegiance" ||
                    userInfo.userData.ContractIdentified === "Disney-HMSA Kaiser")
                ) {
                setShowDisneyModal(true);
                setModalMessage(t('eggfreezing'));
                } else {
                setShowDisneyModal(false);
                }
            };

      const handleModalClose = () => {
        setShowNurseModal(false);
        setShowscheduleModal(true);
        //navigate(-1);
      };
      const handleclosenurse=()=>{
        setShowscheduleModal(false);
        navigate(-1);
      }
      const handleNurseOkay = () => {
        setShowNurseModal(false);
        navigate("/book-appointment"); // Adjust the route as needed
    };

    return(
        <>

        {isHighmarkPortal ? 
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-heading">{t('reviewRX')}</h2>
          </div>:
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">{t('reviewRX')}</h2>
          </div>
      }

            {/* <div className="col-12 mt-4 inner-page-heading-wrapper">
                <button onClick={handleBackClick} className="win-back-btn"><span><i class='bi bi-chevron-left'></i>{t('Back')}</span></button>
                <h2 className="page-heading">{t('reviewRX')}</h2>
            </div> */}

            <div className="col-md-12 col-lg-6 mt-2">
                
            <div className="mb-4 row align-items-center">
                <label
                  htmlFor="date"
                  className="col-sm-12 model-form-label" // Add a class for better control
                  style={{ display: 'block' }} 
                >
                 {t('selectMedicationsNeededBy')}
                </label>
                <div className="col-sm-8">
                    <DatePicker
                    selected={selectedDate}  // Binds the selected date to the component
                    onChange={(date) => {
                        setSelectedDate(date);  // Updates the state with the selected date
                        //    console.log("Selected Date:", date);  // Logs to verify the date
                    }}
                    dateFormat="MM/dd/yyyy"
                    className="form-control win-form-control calendar-control mobile-view"
                    id="date"
                    placeholderText="MM/DD/YYYY"
                    showYearDropdown
                    scrollableYearDropdown
                    minDate={new Date()}
                    onKeyDown={(e) => e.preventDefault()} 
                    />
                </div>
              </div>
             {/* Dropdown for Elective Egg Freezing Cycle */}
                <div className="mb-4 row align-items-center">
                    <label htmlFor="eggFreezing" className="col-sm-12 model-form-label">
                        {t('Are these medications for an elective egg freezing cycle?')}
                    </label>
                    <div className="col-sm-8 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
                        <RegistrationDropdown
                            id="eggFreezing"
                            options={[
                                { id: 'Yes', name: 'Yes' },
                                { id: 'No', name: 'No' },
                            ]}
                            selectedOption={{ id: selectedEggFreezing, name: selectedEggFreezing }}
                            onChange={handleEggFreezingChange} // Trigger modal on change
                            label={t('Egg Freezing Cycle')}
                            searchable={false}
                            />
                        </div>
                </div>

              <div className="mb-4 row align-items-center">
                  <label
                    htmlFor="pharmacy"
                    className="col-sm-4 model-form-label"
                  >
                    {t('pharmacy')}
                  </label>
                  <div className="col-sm-8 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
                  <RegistrationDropdown
                        id="pharmacy"
                        options={reviewData?.Pharmacies.map((pharmacy) => ({
                        id: pharmacy.PharmCode,
                        name: pharmacy.PharmName,
                        }))}
                        selectedOption={
                        selectedPharmacy
                            ? { id: selectedPharmacyCode, name: selectedPharmacy }
                            : null
                        }
                        onChange={handlePharmacyChange}
                        label="Pharmacy"
                        searchable
                        disabled={userTypePremier === 'No' && userTypePremierRX==='No' }
                    />
                    </div>
                </div>
                {((userTypePremier !== 'No') || (userTypePremierRX !== 'No'))&& (       
                <div className="mb-4 row align-items-center">
                    <label className="col-sm-4"></label>
                    <div className="col-sm-12">
                        <button type="submit" className="win-btn-primary-w-content mobile-view mt-4" onClick={handleFindCheapestPharmacy}>{t('pickBestPharmacy')}</button>
                    </div>
                </div>
                )}
                <div className="mb-4 row align-items-center">
                    <label className="col-sm-4"></label>
                    <div className="col-sm-8">
                    {t('medicationQuantityInstructions')}
                    </div>
                </div>

                {reviewData?.Rx?.map((medication) => (
                    <div key={medication.PresId} className="mb-4 row align-items-center">
                        <label className="col-sm-4 model-form-label">
                            {medication.DrugName}
                        </label>
                        <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control win-form-control mobile-view"
                            placeholder="Home Qty"
                            value={homeQty[medication.PresId] || ""}
                            onChange={(e) => handleHomeQtyChange(medication.PresId, e.target.value)}
                        />
                        </div>
                    </div>
                ))}
              <div className="mb-4 row align-items-center">
                <label className="col-sm-4"></label>
                <div className="col-sm-8">
                    <button type="submit" className="win-btn-primary mobile-view mt-4" onClick={handleSubmit}>{t('submit')}</button>
                    </div>
                </div>
                <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)} showConfirmButtons={showConfirmButtons}  onOkay={handleOkayClick} />
            </div>
            <ErrorModal
                show={showscheduleModal}
                onClose={handleclosenurse}
                showConfirmButtons={true}
                message={"Would you like to schedule a call with a nurse?"}
                onOkay={handleNurseOkay}
            />
            <ErrorModal  show={showNurseModal}
                message={modalMessage} onClose={handleModalClose} closeButton={true}  />

         <ErrorModal show={showDisneyModal} 
         message={modalMessage} 
         onClose={() => setShowDisneyModal(false)} 
         isEggFreezing={true}  
         onOkay={() => setShowDisneyModal(false)} />
        </>
    )
}

export default Review_RX;